module.exports = __webpack_public_path__ + "static/img/placeholder.670cb07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lekkerhot/placeholder.png
// module id = 1Iba
// module chunks = 0